import './resultPreviewTableListComponent.scss';
import React from 'react';
import {APIConfig} from "../../../../constants";
import {ITableColumn} from "../../../../shared/models/table.model";
import TableWrapperV2Component
    from "../../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import TooltipComponent from "../../../../shared/components/tooltip/tooltipComponent";
import {CommonService} from "../../../../shared/services";
import commonService from "../../../../shared/services/common.service";

interface ResultPreviewTableListComponentProps {
    sessionID: any;
}

const ResultPreviewTableListComponent = (props: ResultPreviewTableListComponentProps) => {
        const {sessionID} = props;
        const columns: ITableColumn[] = [
            {
                id: 'orderDetails.code', label: 'GK Number', align: 'center', fixed: "left",
            },
            {
                id: 'sampleDetails.barcode', label: 'Accession ID', align: 'center',
            },

            {
                id: 'patient', label: 'Patient', width: "230",
                isDefaultColumn: true,
                content: (item: any) => (
                    <>
                        {
                            item?.orderDetails?.patientDetails ? <>
                                {
                                    (item?.orderDetails?.patientDetails?.firstName + ' ' + item?.orderDetails?.patientDetails?.lastName).length > 30 ?
                                        <TooltipComponent
                                            tooltip={CommonService.capitalizeFirstLetterOfEachWord(item?.orderDetails?.patientDetails?.firstName) + " " + CommonService.capitalizeFirstLetterOfEachWord(item?.orderDetails?.patientDetails?.lastName)}
                                            placement={"top"}
                                            arrow={true}
                                        >
                                            <div className={"ellipses-for-table-data"}>
                                                {CommonService.capitalizeFirstLetterOfEachWord(item?.orderDetails?.patientDetails?.firstName)} {CommonService.capitalizeFirstLetterOfEachWord(item?.orderDetails?.patientDetails?.lastName)}
                                            </div>
                                        </TooltipComponent> :
                                        <>
                                            {CommonService.capitalizeFirstLetterOfEachWord(item?.orderDetails?.patientDetails?.firstName)} {CommonService.capitalizeFirstLetterOfEachWord(item?.orderDetails?.patientDetails?.lastName)}
                                        </>

                                }
                                <br/>
                                {
                                    item?.orderDetails?.patientDetails?.gender && <>
                                        (&nbsp;{item?.orderDetails?.patientDetails?.gender[0]?.toUpperCase()}&nbsp;)&nbsp;
                                    </>
                                }
                                {commonService.formatDate(item?.orderDetails?.patientDetails?.dateOfBirth)}
                            </> : <> - </>
                        }
                    </>
                )
            },
            {
                id: 'orderingBy', label: 'Order By', align: 'center',
                content: (item: any) => (
                    <>
                        {
                            item?.sampleDetails?.physicianDetails ?
                                <>
                                    {item?.sampleDetails?.physicianDetails?.firstName || '-'} {item?.sampleDetails?.physicianDetails?.lastName || '-'}
                                </> : <> - </>
                        }
                    </>
                )
            },

            {
                id: 'collectionDate', label: 'Collection Date & Time', align: 'center',
                content: (item: any) => (
                    <React.Fragment>
                        <>
                            {
                                item ?
                                    <>{item?.sampleDetails?.dateOfCollection ? item?.sampleDetails?.dateOfCollection : '-'}
                                        &nbsp;|&nbsp;
                                        {item?.sampleDetails?.timeOfCollection ? item?.sampleDetails?.timeOfCollection : '-'}
                                    </> : <> - </>
                            }
                        </>

                    </React.Fragment>
                )
            },

            {
                id: 'isResultMatched', label: 'Status', align: 'center',
                content: (item: any) => (
                    <>{item.isResultMatched ? 'Matched' : 'Not Matched'}</>
                )
            },
            {
                id: 'isPdfGenerated', label: 'Report', align: 'center', fixed: "right",
                content: (item: any) => (
                    <>{item.isPdfGenerated ? 'Generated' : 'Not Generated'}</>
                )
            }

        ];

        return (
            <div className="table-list-container t-table-inside-preview">
                <TableWrapperV2Component
                    url={APIConfig.SESSION_LIST.URL(sessionID)}
                    method={APIConfig.SESSION_LIST.METHOD}
                    isPaginated={true}
                    columns={columns}
                    isHoverable={true}
                    isStickyHeader={true}
                    moduleName={"ResultPreviewTableListComponent"}
                />
            </div>
        )
    }

;

export default ResultPreviewTableListComponent;
